import { AlertsHub } from './AlertsHub';
import { ChaosApolloProvider } from './graphql';

export const AlertsHubPortal = () => (
  <ChaosApolloProvider>
    <AlertsHub />
  </ChaosApolloProvider>
);
